import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Drawer, Typography, Avatar } from '@mui/material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
//
import navConfig from './config';

// ----------------------------------------------------------------------

const NAV_WIDTH = 360; // širina povećana

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 0.5, // manji radius
  backgroundColor: 'transparent', // ili neka boja po želji
}));


// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
  headerHeight: PropTypes.number,  // ✅
};

export default function Nav({ openNav, onCloseNav, headerHeight }) {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  const { user: currentUser } = useSelector((state) => state.auth);

  const filteredNavConfig = navConfig.filter(item =>
    currentUser?.roles?.some(role => item.roles.includes(role))
  );

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  const renderContent = (
    <Scrollbar
      sx={{
        backgroundColor: '#001536',
        color: '#FFA500',
        height: 1,

        '& *': {
          color: '#FFA500 !important',
          fontWeight: 'bold',
          fontSize: '2rem',
        },
        '& .MuiListItemButton-root': {
          paddingTop: '24px',
          paddingBottom: '24px',
          marginBottom: '24px',
        },
        '& .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root.Mui-selected:hover': {
          color: '#FFFFFF !important',
        },
        '& *:hover': {
          color: '#FFFFFF !important',
        },
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {/* LOGO NA VRHU 
      <Box
        sx={{
          px: 2.5,
          py: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Logo />
      </Box>
      */}

{/* AVATAR / USER INFO */}
<Box sx={{ mb: 2, mt: 2, mx: 2 }}>
  <Link underline="none">
    <StyledAccount sx={{ 
      width: '100%',                   // prati širinu Box-a
      backgroundColor: '#00122E',      // boja pozadine
      borderRadius: '20px',            // radius
      padding: '8px 16px',             // padding
      border: '1px solid rgba(255,255,255,0.2)', // okvir
      boxShadow: '0 4px 12px rgba(0,0,0,0.2)',    // opcionalno, blagi shadow
    }}>
      <Avatar src={'/assets/images/photos/photo_8.jpg'} alt="photoURL" />
      <Box sx={{ ml: 2 }}>
        <Typography variant="subtitle2">
          {currentUser.username}
        </Typography>
        <Typography variant="body2">
          {currentUser.roles}
        </Typography>
      </Box>
    </StyledAccount>
  </Link>
</Box>

{/* OKVIR ZA STAVKE MENIJA */}
<Box
  sx={{
    mx: 2,                        // ista širina kao avatar box
    my: 2,
    p: 2,
    borderRadius: '20px',
    border: '1px solid rgba(255,255,255,0.2)',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#00122E'
  }}
>
  <NavSection data={filteredNavConfig} />
</Box>


      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {/* DESKTOP */}
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: '#002055',
              borderRightStyle: 'dashed',

              top: headerHeight,                               // ✅
              height: `calc(100% - ${headerHeight}px)`,       // ✅
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        /* MOBILE */
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{ keepMounted: true }}
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: '#002055',
              top: headerHeight,                               // ✅ dodano
              height: `calc(100% - ${headerHeight}px)`,       // ✅ dodano
            },
          }}
        >
          {renderContent}
        </Drawer>

      )}
    </Box>
  );
}
